import React, { useState, useContext } from "react";
import { Dropdown, Offcanvas, Button, ListGroup, Spinner, InputGroup, Image, Form } from "react-bootstrap";
import LogoutButton from "./buttons/LogoutButton";
import Icon from '@mdi/react';
import { FaReceipt, FaSlidersH } from 'react-icons/fa';
import { mdiCartOutline, mdiTrashCanOutline, mdiBaseballDiamondOutline } from '@mdi/js';
import { PendingOrderContext } from './orders/PendingOrderProvider';
import { apiFetch } from "../apiClient";
import useMyDetails from '../hooks/useMyDetails';
import useUserRoles from '../hooks/useUserRoles';
import NotificationDropdown from './notifications/NotificationDropdown';

function Header() {
    const { isCommissioner } = useUserRoles();

    const {
        data: userData,
        isLoading: detailsLoading,
        error: detailsError,
    } = useMyDetails();


    const { hasPendingOrder, refreshPendingOrder } = useContext(PendingOrderContext);
    const [showCart, setShowCart] = useState(false);
    const [cartOrder, setCartOrder] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleShowCart = () => {
        setShowCart(true);
        fetchCartItems(); // Load cart items when opening
    };
    const handleCloseCart = () => setShowCart(false);

    // Fetch order details
    const fetchCartItems = async () => {
        setLoading(true);
        try {
            const response = await apiFetch('/api/orders/my-pending/');
            if (response.ok) {
                const data = await response.json();
                setCartOrder(data.order ?? null);
                setCartItems(data.order?.items ?? []);
            } else {
                console.error("Failed to fetch cart items:", response.status, response.statusText);
                setCartOrder(null);
                setCartItems([]);
            }
        } catch (error) {
            console.error("Error fetching cart items:", error);
            setCartItems([]);
        } finally {
            setLoading(false);
        }
    };

    // Remove item from order
    const handleRemoveItem = async (seasonId) => {
        try {
            const response = await apiFetch('/api/orders/remove-season/', {
                method: 'POST',
                body: JSON.stringify({ season_id: seasonId }),
            });

            if (response.ok) {
                setCartItems(prev =>
                    prev.filter(item => item.product.id !== seasonId)
                );
                refreshPendingOrder(); // Refresh global cart state
            } else {
                console.error("Failed to remove item from cart");
            }
        } catch (error) {
            console.error("Error removing item:", error);
        }
    };

    const handleQuantityChange = async (itemId, newQuantity) => {
        if (newQuantity < 1) return; // Prevent zero or negative values

        try {
            const response = await apiFetch('/api/orders/update-quantity/', {
                method: 'POST',
                body: JSON.stringify({ item_id: itemId, quantity: newQuantity }),
            });

            if (response.ok) {
                const data = await response.json();
                setCartItems(data.order.items); // Update cart items with new data
            } else {
                console.error("Failed to update item quantity");
            }
        } catch (error) {
            console.error("Error updating quantity:", error);
        }
    };

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href="/"
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            className="nav-link bg-light icon-md btn btn-light p-0"
        >
            {children}
        </a>
    ));


    if (detailsLoading) return <Spinner animation="border" size="sm" />;
    if (detailsError) return null;

    return (
        <>
            <header className="navbar-light fixed-top header-static bg-mode">
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        {/* Logo START */}
                        <a className="navbar-brand" href="/profile/">
                            <img
                                className="light-mode-item navbar-brand-item"
                                src={`/static/images/kb_static/lemont_rec_leagues.png`}
                                alt="logo"
                            />
                            <img
                                className="dark-mode-item navbar-brand-item"
                                src={`/static/images/kb_static/lemont_rec_leagues.png`}
                                alt="logo"
                            />
                        </a>
                        {/* Logo END */}

                        {/* Responsive navbar toggler */}
                        {/* <button
                            className="navbar-toggler ms-auto icon-md btn btn-light p-0"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarCollapse"
                            aria-controls="navbarCollapse"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-animation">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button> */}

                        {/* Main navbar START */}
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            {/* Nav Search START */}
                            {/* <div className="nav mt-3 mt-lg-0 flex-nowrap align-items-center px-4 px-lg-0">
                                <div className="nav-item w-100">
                                    <form className="rounded position-relative">
                                        <input
                                            className="form-control ps-5 bg-light"
                                            type="search"
                                            placeholder="Search..."
                                            aria-label="Search"
                                        />
                                        <button
                                            className="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
                                            type="submit"
                                        >
                                            <i className="bi bi-search fs-5"></i>
                                        </button>
                                    </form>
                                </div>
                            </div> */}
                            {/* Nav Search END */}
                        </div>
                        {/* Main navbar END */}

                        {/* Nav right START */}

                        <ul className="nav flex-nowrap align-items-center ms-sm-3 list-unstyled">
                            {/* Advanced filter responsive toggler START */}
                            <li className="nav-item d-lg-none ms-2">
                                <button
                                    type="button"
                                    className="nav-link icon-md btn btn-light bg-light p-0"
                                    data-bs-toggle="offcanvas"
                                    data-bs-target="#offcanvasSideNavbar"
                                    aria-controls="offcanvasSideNavbar"
                                    aria-label="Open advanced filters"
                                >
                                    <FaSlidersH />
                                </button>
                            </li>
                            {/* Advanced filter responsive toggler END */}

                            {/* <li className="nav-item ms-2">
                                <a className="nav-link bg-light icon-md btn btn-light p-0" href="messaging.html">
                                    <i className="bi bi-chat-left-text-fill fs-6"></i>
                                </a>
                            </li> */}
                            {isCommissioner && (
                                <li className="nav-item ms-2">
                                    <a className="nav-link bg-light icon-md btn btn-light p-0" href="/league-manager/">
                                        <Icon className="me-1" path={mdiBaseballDiamondOutline} size={1} />
                                    </a>
                                </li>
                            )}
                            <li className="nav-item ms-2">
                                <a className="nav-link bg-light icon-md btn btn-light p-0" href="/settings">
                                    <i className="bi bi-gear-fill fs-6"></i>
                                </a>
                            </li>
                            <li className="nav-item dropdown ms-2">
                                <NotificationDropdown CustomToggle={CustomToggle} />
                            </li>
                            {/* Cart Icon with conditional badge */}
                            <li className="nav-item dropdown ms-2">
                                <div>
                                    {/* <a className="nav-link bg-light icon-md btn btn-light p-0" href="/settings">
                                        {hasPendingOrder && (
                                            <span className="badge-notif animation-blink"></span>
                                        )}
                                        <Icon path={mdiCartOutline} size={1} />
                                    </a> */}
                                    <Button
                                        variant="light"
                                        className="nav-link bg-light icon-md btn btn-light p-0"
                                        onClick={handleShowCart}
                                    >
                                        {hasPendingOrder && (
                                            <span className="badge-notif animation-blink"></span>
                                        )}
                                        <Icon path={mdiCartOutline} size={1} />
                                    </Button>
                                </div>
                            </li>
                            <li className="nav-item dropdown ms-2">
                                <Dropdown align="end">
                                    <Dropdown.Toggle
                                        as={CustomToggle}
                                        className="nav-link btn icon-md p-0"
                                        id="profileDropdown"
                                        data-bs-auto-close="outside"
                                        data-bs-display="static"
                                    >
                                        <img
                                            className="avatar-img rounded-2"
                                            src={
                                                userData.profile_picture ? userData.profile_picture : `/static/images/kb_static/lemont_rec_leagues_circle.png`
                                            }
                                            alt={`${userData.first_name} ${userData.last_name}`}
                                        />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-menu dropdown-animation dropdown-menu-end pt-3 small me-md-n3">
                                        <Dropdown.Item as="div">
                                            <div className="d-flex align-items-center position-relative">
                                                <div className="avatar me-3">
                                                    <img
                                                        className="avatar-img rounded-circle"
                                                        src={
                                                            userData.profile_picture ? userData.profile_picture : `/static/images/kb_static/lemont_rec_leagues_circle.png`
                                                        }
                                                        alt={`${userData.first_name} ${userData.last_name}`}
                                                    />
                                                </div>
                                                <div>
                                                    <a className="h6 stretched-link" href="/">{userData.first_name} {userData.last_name}</a>
                                                    <p className="small mb-0">{userData.current_team?.name || 'No team'}</p>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item href="/settings">
                                            <i className="bi bi-gear fa-fw me-2"></i> Settings & Privacy
                                        </Dropdown.Item>
                                        <Dropdown.Item href="/orders/my-orders">
                                            <FaReceipt className="me-1" size={16} /> My Orders
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                        <LogoutButton />
                                    </Dropdown.Menu>
                                </Dropdown>
                            </li>
                        </ul>
                        {/* Nav right END */}
                    </div>
                </nav>
            </header>
            {/* Offcanvas Shopping Cart */}
            <Offcanvas show={showCart} onHide={handleCloseCart} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Shopping Cart</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    ) : cartItems.length === 0 ? (
                        <p className="text-center">Your cart is empty.</p>
                    ) : (
                        <>
                            <ListGroup variant="flush">
                                {cartItems.map((item) => (
                                    <ListGroup.Item key={item.id} className="d-flex flex-column w-100">
                                        {/* First Row: Image & Product Details */}
                                        <div className="d-flex align-items-center w-100">
                                            {/* Product Image */}
                                            <Image
                                                src={item.product.image || `/static/images/avatar/placeholder.jpg`}
                                                alt={item.product.name}
                                                className="icon-shape icon-xxl"
                                                rounded
                                                width={50}
                                            />
                                            <div className="ms-3 flex-grow-1">
                                                {/* Product Name */}
                                                <strong className="d-block">
                                                    <a href={`/product/${item.product.id}`} className="text-inherit text-decoration-none">
                                                        {item.product.name}
                                                    </a>
                                                </strong>
                                                {/* Product Price */}
                                                <span className="text-muted">
                                                    ${item.product.current_fee.toFixed(2)}
                                                </span>
                                            </div>
                                            {/* Remove Button */}
                                            <Button variant="link" className="text-danger p-0 ms-auto" onClick={() => handleRemoveItem(item.product.id)}>
                                                <Icon path={mdiTrashCanOutline} size={0.8} className="me-1" />
                                                Remove
                                            </Button>
                                        </div>

                                        {/* Second Row: Quantity Selector */}
                                        <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                                            {/* Quantity Controls */}
                                            {item.content_type_name !== 'season' && (
                                                <InputGroup className="input-group-sm w-auto">
                                                    <Button
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                                                        disabled={item.quantity <= 1}
                                                        className="rounded-start px-2"
                                                    >
                                                        −
                                                    </Button>
                                                    <Form.Control
                                                        type="number"
                                                        value={item.quantity}
                                                        onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value))}
                                                        min="1"
                                                        max="10"
                                                        className="text-center"
                                                        style={{ width: "50px", borderLeft: "0", borderRight: "0" }}
                                                    />
                                                    <Button
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                                                        className="rounded-end px-2"
                                                    >
                                                        +
                                                    </Button>
                                                </InputGroup>
                                            )}
                                            {/* Item Price */}
                                            <div className="d-flex flex-column align-items-end">
                                                {item.quantity > 1 && (
                                                    <small className="text-muted">
                                                        ${item.product.current_fee.toFixed(2)} each
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>

                            {/* Cart Summary */}
                            <div className="border-top mt-3 pt-3">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted">Subtotal</span>
                                    <span className="fw-bold">${cartOrder.subtotal}</span>
                                </div>
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-muted">Taxes & Fees</span>
                                    <span className="fw-bold">${cartOrder.fee_total}</span>
                                </div>
                                <div className="d-flex justify-content-between border-top pt-2 mt-2">
                                    <span className="fw-bold">Total</span>
                                    <span className="fw-bold text-primary fs-5">${cartOrder.total_amount}</span>
                                </div>
                            </div>

                            <div className="mt-3">
                                <Button
                                    as="a"
                                    href={`/orders/${cartOrder.id}/checkout/`}
                                    variant="success"
                                    className="w-100"
                                >
                                    Checkout
                                </Button>
                            </div>
                        </>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default Header;
